import React from "react";

import PropTypes from "prop-types";

import { UPSELL_PRODUCT_CODES } from "_constants";

import ExtensionUpsell from "components/Modals/Upsells/ExtensionUpsell";
import StatementOfUseUpsell from "components/Modals/Upsells/StatementOfUseUpsell";
import CertifiedCopyUpsell from "components/Modals/Upsells/CertifiedCopyUpsell";
import TrademarkMonitoringUpsell from "components/Modals/Upsells/TrademarkMonitoringUpsell";
import RenewalUpsell from "components/Modals/Upsells/RenewalUpsell";
import RevivalFromAbandonmentUpsell from "components/Modals/Upsells/RevivalFromAbandonmentUpsell";

export function UpsellModal({ upsellInfo, onCancel }) {
  const { productCode } = upsellInfo || {};

  const upsellProps = {
    upsellInfo,
    onCancel,
  };

  switch (productCode) {
    case UPSELL_PRODUCT_CODES.extension:
      return <ExtensionUpsell {...upsellProps} />;

    case UPSELL_PRODUCT_CODES.statementOfUse:
      return <StatementOfUseUpsell {...upsellProps} />;

    case UPSELL_PRODUCT_CODES.certifiedCopy:
      return <CertifiedCopyUpsell {...upsellProps} />;

    case UPSELL_PRODUCT_CODES.trademarkMonitoring:
      return <TrademarkMonitoringUpsell {...upsellProps} />;

    case UPSELL_PRODUCT_CODES.keepTrademarkAlive:
      return <RenewalUpsell {...upsellProps} />;

    case UPSELL_PRODUCT_CODES.revivalFromAbandonment:
      return <RevivalFromAbandonmentUpsell {...upsellProps} />;

    default:
      return null;
  }
}

UpsellModal.propTypes = {
  upsellInfo: PropTypes.shape({
    productCode: PropTypes.string,
    id: PropTypes.string,
    productId: PropTypes.string,
  }),
  onCancel: PropTypes.func,
};
